import { render, staticRenderFns } from "./Graph.vue?vue&type=template&id=f04883fe"
import script from "./Graph.vue?vue&type=script&lang=js"
export * from "./Graph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f04883fe')) {
      api.createRecord('f04883fe', component.options)
    } else {
      api.reload('f04883fe', component.options)
    }
    module.hot.accept("./Graph.vue?vue&type=template&id=f04883fe", function () {
      api.rerender('f04883fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/Graph.vue"
export default component.exports